// libs
import React, { useMemo } from 'react';

import { cn } from '@lyearn/style';
import { NAV_SECTION_IDS } from '@/modules/corporate/navigation/consts';

// hooks
import { SidebarItems } from '../../hooks/useSidebar';
import UserInfoWithWorkspace from '../UserInfoWithWorkspace';
import SidebarFooter from './SidebarFooter';
import SidebarHeader from './SidebarHeader';
import MenuItems from './SidebarItems';
import { SIDEBAR_LINE, SIDEBAR_PANEL } from './theme';

const Sidebar = ({
  className,
  sidebarItems,
  showUserProfile,
  logoOnlyHeader,
  collapsed = false,
}: {
  className?: string;
  sidebarItems: SidebarItems;
  showUserProfile: boolean;
  logoOnlyHeader?: boolean;
  collapsed?: boolean;
}) => {
  const { sections, footerItems } = useMemo(
    () => ({
      sections: sidebarItems.filter((section) => section.id !== NAV_SECTION_IDS.Footer),
      footerItems: sidebarItems
        .filter((section) => section.id === NAV_SECTION_IDS.Footer)
        .flatMap((section) => section.children),
    }),
    [sidebarItems],
  );

  return (
    <nav
      aria-label="Main navigation"
      className={cn(
        'flex h-full w-full flex-col overflow-hidden border-e',
        SIDEBAR_LINE,
        SIDEBAR_PANEL,
        className,
      )}>
      {logoOnlyHeader ? (
        <SidebarHeader collapsed={collapsed} />
      ) : showUserProfile ? (
        <UserInfoWithWorkspace />
      ) : null}

      <div className="flex min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto px-12 pb-12">
        <MenuItems collapsed={collapsed} sidebarItems={sections} />
      </div>

      <SidebarFooter
        collapsed={collapsed}
        items={footerItems}
        showAccount={logoOnlyHeader ? showUserProfile : false}
      />
    </nav>
  );
};

export default React.memo(Sidebar);
